import { create } from 'zustand';
import { PatientQuery } from '@/schema/patient';
import { PageParam } from '@/schema/page';

interface PatientState {
  selectedPatients: Set<string>;
  setSelectedPatients: (patients: string[]) => void;

  query: PatientQuery;
  setQuery: (partial: Partial<PatientQuery>) => void;

  pageable: PageParam;
  setPageable: (page: number) => void;
}

export const patientStore = create<PatientState>((set, get) => {
  return {
    selectedPatients: new Set<string>(),
    setSelectedPatients: (patients: string[]) => {
      set({ selectedPatients: new Set(patients) });
    },

    query: {
      status: null,
      search: undefined,
      scanDateFrom: undefined,
      scanDateTo: undefined,
      clinicId: undefined,
    },
    setQuery: (partial) => {
      set((state) => ({
        query: {
          ...state.query,
          ...partial,
        },
        pageable: {
          ...state.pageable,
          page: 0,
        },
      }));
    },
    pageable: {
      page: 0,
      size: 10,
    },
    setPageable: (page: number) => {
      set({
        pageable: {
          ...get().pageable,
          page,
        },
      });
    },
  };
});
